import { Dispatch, FC, SetStateAction, useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import { useForm, FormProvider } from 'react-hook-form'
import { BrowserMultiFormatReader } from '@zxing/browser'
import { yupResolver } from '@hookform/resolvers/yup'
import { schemaOrderLaundryReceptionTypeClothe } from '../../../../../../util/validationLavanderia'
import { getMasterService } from '../../../../../central/services'
import { AppTypeClothe } from '../../../../model'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { Select } from '../../../../../../components/UI/Select'
import { InputText, InputTextArea } from '../../../../../../components/UI/Input'
import { getSequenceId } from '../../../../services'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  setIdDetail: Dispatch<SetStateAction<any>>
  setData: (e: any) => void
  setCorrelativoId: Dispatch<SetStateAction<string>>
  setCampamentoId: Dispatch<SetStateAction<string>>
  detailpermission?: any
  idPermission?: any
}

const ModalAddClothe: FC<Props> = ({
  show,
  setShow,
  setData,
  detailpermission,
  idPermission,
  setIdDetail,
  setCorrelativoId,
  setCampamentoId
}) => {
  const [isBack, setBack] = useState<boolean | any>(null)
  const [typeFurniture, setTypeFurniture] = useState<AppTypeClothe[] | any>([])

  const methods = useForm<AppTypeClothe>({
    resolver: yupResolver(schemaOrderLaundryReceptionTypeClothe),
  })

  const {
    control,
    setValue,
    handleSubmit,
    register,
    formState: { errors },
  } = methods

  // === ESTADO / REFS DEL ESCÁNER ===

  const [isOpenCamera, setIsOpenCamera] = useState(false)
  const [barcode, setBarcode] = useState('')
  const [scanError, setScanError] = useState<string | null>(null)
  const [isValidating, setIsValidating] = useState(false)
  const [isValidatingOk, setIsValidatingOk] = useState(false)
  const [formEnabled, setFormEnabled] = useState(false)

  const videoRef = useRef<HTMLVideoElement | null>(null)
  const readerRef = useRef<BrowserMultiFormatReader | null>(null)
  const controlsRef = useRef<any>(null)
  const isProcessingRef = useRef(false)

  const handleCleanCode = () => {
    setBarcode('')
    setValue('cantidad', '')
    // setBack(true)
    setCorrelativoId(null);
    setCampamentoId(null);
    setIsValidatingOk(false)
    setFormEnabled(false)
  }

  const handleSearchCode = async () => {
    if ((barcode ?? "").length > 0) {
      handleBarcodeDetected(barcode)
    } else {
      startScanner();
    }
  }

  const startScanner = async () => {
    setScanError(null)
    setBarcode('')
    setIsOpenCamera(true)
    if (!readerRef.current) {
      readerRef.current = new BrowserMultiFormatReader()
    }

    try {
      const devices = await BrowserMultiFormatReader.listVideoInputDevices()

      if (!devices || devices.length === 0) {
        alert('No se encontró ninguna cámara')
        setIsOpenCamera(false)
        return
      }

      const deviceId = devices[devices.length - 1].deviceId

      isProcessingRef.current = false

      controlsRef.current = await readerRef.current.decodeFromVideoDevice(
        deviceId,
        videoRef.current!,
        (result, error) => {
          if (result && !isProcessingRef.current) {
            isProcessingRef.current = true
            const text = result.getText()
            handleBarcodeDetected(text)
          }
        },
      )
    } catch (err) {
      console.error('Error iniciando cámara:', err)
      setIsOpenCamera(false)
    }
  }

  const stopScanner = () => {
    try {
      controlsRef.current?.stop()
      controlsRef.current = null
      // readerRef.current?.reset()
    } catch (e) {
      console.warn('Error al detener el scanner:', e)
    }
    setIsOpenCamera(false)
  }

  const handleBarcodeDetected = async (code: string) => {
    stopScanner()
    setBarcode(code)
    setScanError(null)
    setIsValidating(true)
    setIsValidatingOk(false)
    setFormEnabled(false)

    try {
      const data = await getSequenceId(code)
      switch (data?.data?.estadoCorrelativo) {
        case 'DIS':
          setValue('cantidad', '1')
          setBack(true)
          setCorrelativoId(data.data.id);
          setCampamentoId(data.data.campamentoId);
          setIsValidatingOk(true)
          setFormEnabled(true)
          break;
        case 'USO':
          setScanError(`El código está siendo usado en la orden N° ${data?.data?.nroOrdenLavado ?? '-'}`)
          break;
        case 'INH':
          setScanError(`El código está siendo inhabilitado`)
          break;
        default:
          setScanError(`El código no existe`)
          break;
      }
    } catch (e: any) {
      console.error(e)
      setScanError(e.message || 'Error validando el código')
      setFormEnabled(false)
      setIsValidatingOk(false)
    } finally {
      setIsValidating(false)
    }
  }

  useEffect(() => {
    return () => {
      try {
        controlsRef.current?.stop()
        controlsRef.current = null
      } catch { }
    }
  }, [])

  const getTypeFurnitureList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRopa',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    if (idPermission) {
      setValue('tipoRopa', detailpermission?.tipoRopa)
      setValue('cantidad', detailpermission?.cantidad)
      setValue('observacionColor', detailpermission?.observacionColor)
      setFormEnabled(true) // si estás viendo/edición, habilitamos el form
    }
  }, [idPermission])

  useEffect(() => {
    getTypeFurnitureList()
  }, [])

  const handleClose = () => {
    setShow(false)
  }

  const handleChangeSelect = (e: any) => {
    setBack(e.target.checked)
  }

  const onSubmit = async (data: AppTypeClothe) => {
    try {
      setData(data)
      setValue('tipoRopa', '')
      setValue('cantidad', '1')
      setValue('observacionColor', '')
      setIdDetail(null)
      if (!isBack) {
        handleClose()
      }
    } catch (error) { }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content position-relative'>
        {isOpenCamera && (
          <div
            className='position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-dark bg-opacity-75'
            style={{ zIndex: 1055 }}
          >
            <div className='bg-black rounded-3 p-3' style={{ width: '100%', maxWidth: 420 }}>
              <div className='d-flex justify-content-between align-items-center mb-2'>
                <span className='text-white fw-bold'>Escanear código de barra</span>
                <button type='button' className='btn btn-sm btn-light' onClick={stopScanner}>
                  Cerrar
                </button>
              </div>
              <video ref={videoRef} style={{ width: '100%', borderRadius: '8px' }} />
              <div className='mt-2 text-center'>
                <small className='text-white-50'>Apunta la cámara al código de barras</small>
              </div>
            </div>
          </div>
        )}

        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Ver Ropa</h5>
          ) : (
            <h5 className='modal-title'>Agregar Ropa</h5>
          )}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='col-sm-12 col-lg-8'>
              <div className='d-flex flex-column mb-3'>
                <div className='input-group'>
                  <input type='text' disabled={isValidatingOk} className='form-control' placeholder='Ingresa o escanea el código' value={barcode || ''}
                    onChange={(e) => setBarcode(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') handleSearchCode()
                    }}
                  />
                  {isValidatingOk ?
                    (<button className='btn btn-danger' type='button' onClick={handleCleanCode} disabled={false}>
                      <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1 m-0' />
                    </button>) :
                    (<button className='btn btn-secondary' type='button' onClick={handleSearchCode} disabled={false}>
                      <KTSVG path='/media/icons/duotune/social/soc005.svg' className='svg-icon-1 m-0' />
                    </button>)}
                </div>
                <div className='mt-1'>
                  {isValidating && (
                    <p className='mt-1 text-info'>Validando código, por favor espera...</p>
                  )}
                  {isValidatingOk && (
                    <p className='mt-1 text-success'>¡Código validado correctamente! La bolsa está disponible.</p>
                  )}
                  {scanError && <p className='mt-1 text-danger'>⚠ {scanError}</p>}
                </div>
              </div>
            </div>
          </div>
          <FormProvider {...methods}>
            <form>
              <fieldset disabled={!formEnabled && !idPermission}>
                <div className='row'>
                  <div className='mb-2 col-sm-12 col-lg-6'>
                    <label className='required'>Tipo de ropa</label>
                    <Select
                      control={control}
                      name='tipoRopa'
                      data={typeFurniture}
                      errors={errors}
                      disabled={!formEnabled && !idPermission}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-6'>
                    <label className='required'>Cantidad:</label>
                    <InputText
                      name='cantidad'
                      textPlaceholder='Escribe la cantidad'
                      register={register}
                      errors={errors}
                      Uppercase={true}
                      type='number'
                    />
                  </div>
                  <div className='col-sm-12 col-lg-12'>
                    <label>Detalle de Observación:</label>
                    <InputTextArea
                      name='observacionColor'
                      textPlaceholder='Escribe la observación'
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </fieldset>
              <div className='row'>
                <div className='col-sm-12 col-lg-6 d-flex align-items-center'>
                  <div className='form-check form-check-custom form-check-solid pe-2'>
                    <input
                      className='form-check-input border border-gray-500'
                      type='checkbox'
                      data-kt-check={isBack}
                      data-kt-check-target='#kt_table_users .form-check-input'
                      checked={isBack}
                      onChange={handleChangeSelect}
                      disabled={!formEnabled && !idPermission}
                    />
                  </div>
                  <label className='me-2'>Volver agregar</label>
                </div>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSubmit(onSubmit)}
                  disabled={!formEnabled && !idPermission}
                >
                  {idPermission ? 'Guardar' : 'Agregar'}
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export { ModalAddClothe }
